import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import {
  CpFilterSetWrapper,
  CpProjectPlanTagsDivider,
} from 'components/organisms/customer-portal/widgets/cp-project-plan';
import { CpLoadingDesc, CpLoadingProps, CpLoadingTitle } from '../common';

const FilterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--cp-spacing-06);
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const TagSkeleton = styled(Skeleton.Button)`
  width: 110px;
  height: 32px;
  margin-right: var(--cp-spacing-03);

  @media (max-width: 480px) {
    margin-bottom: var(--cp-spacing-03);
    width: 100px;
  }
`;

const Tag: React.FC = () => {
  return <TagSkeleton active shape="round" />;
};

const PhaseSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  .ant-skeleton-button,
  &.ant-skeleton-button,
  & {
    max-width: 100% !important;
    width: 100% !important;
    height: 220px !important;
  }
  margin-top: var(--cp-spacing-06);

  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
  }
`;

const Phase: React.FC = () => {
  return <PhaseSkeleton active shape="square" />;
};

export const CpProjectPlanLoading: React.FC<CpLoadingProps> = ({ styles }) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      <FilterBar>
        <CpFilterSetWrapper className=" md:cp-mb-0 cp-mb-[var(--cp-spacing-05)]">
          <Tag />
          <Tag />
          <Tag />
        </CpFilterSetWrapper>
        <CpProjectPlanTagsDivider className="md:cp-hidden" />
        <CpFilterSetWrapper className=" md:cp-flex md:cp-justify-end cp-justify-start md:cp-mt-0 cp-mt-[var(--cp-spacing-05)]">
          <Tag />
          <Tag />
          <Tag />
        </CpFilterSetWrapper>
      </FilterBar>
      <Phase />
      <Phase />
      <Phase />
    </CpSectionWrapper>
  );
};
